import axios from 'axios';

const { apiUrl, baseUrl, basicAuth, channel } = process.env.CONFIG;
const CancelToken = axios.CancelToken;
const TOKEN_KEY = "token";

export class HttpClient {
    client = "";

    constructor(client = 'admin') {
        this.client = client;

    }


    getTokenKey(client = 'admin') {
        if (client) {
            return TOKEN_KEY + "-" + client;
        } else {
            return TOKEN_KEY
        }
    }

    getLocalToken() {
        return window.local.get(this.getTokenKey(this.client));
    }

    saveToken(token) {
        // noinspection JSUnresolvedVariable
        token.expiresTime = token.expires_in * 1000 + (new Date()).valueOf();
        window.local.save(this.getTokenKey(this.client), token);
    }

    removeToken() {
        window.local.remove(this.getTokenKey(this.client));
    }

    isTokenValid(token) {
        return token && token.expiresTime && (token.expiresTime > (new Date()).valueOf())
    }

    isLogin() {
        return this.isTokenValid(this.getLocalToken())
    }

    requestToken = async (query) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    baseURL: apiUrl,
                    url: "/oauth/token",
                    params: query,
                    method: 'post',
                    timeout: 100000,
                    headers: {
                        'Authorization': "Basic YWRtaW46MTIzNDU2"// + //`${basicAuth[this.client]}`
                    }
                })
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
            }
            catch (e) {
                console.error('requestToken--', e.response)
                reject(e.response);
            }
        });
    };

    async passwordToken(username, password) {
        console.log('passwordToken')
        try {
            const token = await this.requestToken({
                grant_type: 'password',
                username,
                password
            })
            this.saveToken(token);
            return token;
        } catch (e) {
            console.log('e',e)
            return e.status;
        }
    }

    async refreshToken(refreshToken) {
        const token = await this.requestToken({
            grant_type: 'refresh_token',
            refresh_token: refreshToken
        });
        this.saveToken(token);
        return token;
    }

    goLogin(context) {
        context.$router.replace('/login')
    }

    async loadToken(context) {
        const token = this.getLocalToken();
        console.log('getToken',token)
        if (!token) {
            this.goLogin(context);
        } else if (!this.isTokenValid(token)) {
            return await this.refreshToken(token.refresh_token)
        } else {
            return token;
        }
    }

    async buildConfig(method, path, params, body,context, cancelCallBack) {
        let config = {
            baseURL: apiUrl + baseUrl,
            url: path,
            method: method,
            timeout: 100000,
            params: params || {},
            data: body || {},
            headers: {
                'content-type': 'application/json',
            },
            cancelToken: new CancelToken(function executor(c) {
                cancelCallBack && cancelCallBack(c)
            })
        };
        if (!this.client) {
            return config
        }
        const token = await this.loadToken(context);
        if (!token) {
            console.error('token is null')
            return null;
        }
        config.headers.Authorization = 'Bearer ' + token.access_token
        config.url = "/" + this.client + path
        return config
    }

    async request(config,context) {
        if (!config) return null;
        return new Promise(((resolve, reject) => {
            axios(config).then((response) => {
                console.log('config', config)
                resolve(response.data)
            }).catch((error) => {
                console.error('http error', error, config)
                if (error.response.status == 401) {
                    console.log('entry 401', context)
                    this.removeToken();
                    this.goLogin(context);
                }
                reject(error)
            })
        }))
    }

    async post( context=null,path, params, body, cancelCallBack = null) {
        const config = await this.buildConfig('post', path, params, body, context, cancelCallBack);
        return this.request(config,context);
    }

    async get( context=null,path, params = null, cancelCallBack = null) {
        const config = await this.buildConfig('get', path, params, null, context, cancelCallBack);
        return this.request(config,context);
    }

    async get2( context=null,path, params = null, cancelCallBack = null) {
        let config = {
            baseURL: apiUrl + baseUrl,
            url: path,
            method: 'get',
            timeout: 100000,
            params: params || {},
            responseType: 'blob',
            data: null || {},
            headers: {
                'content-type': 'application/json',
            },
            cancelToken: new CancelToken(function executor(c) {
                cancelCallBack && cancelCallBack(c)
            })
        };
        if (!this.client) {
            return config
        }
        const token = await this.loadToken(context);
        if (!token) {
            console.error('token is null')
            return null;
        }
        config.headers.Authorization = 'Bearer ' + token.access_token
        config.url = "/" + this.client + path
        return this.request(config,context);
    }
}


export const buildHttpClient = (client) => new HttpClient(client);

class Http {
    httpClients = {};
    install = (vue) => {
        const that = this;
        vue.mixin({
            created: function () {
                this.$http = buildHttpClient()
            }
        });
    };
}

export const http = new Http();
